'use strict';

exports.__esModule = true;
var splitParagraphs = function splitParagraphs() {
  return function (attributedString) {
    var res = [];

    var start = 0;
    var breakPoint = attributedString.string.indexOf('\n') + 1;

    while (breakPoint > 0) {
      res.push(attributedString.slice(start, breakPoint));
      start = breakPoint;
      breakPoint = attributedString.string.indexOf('\n', breakPoint) + 1;
    }

    if (start < attributedString.length) {
      res.push(attributedString.slice(start, attributedString.length));
    }

    return res;
  };
};

exports.default = splitParagraphs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/layout/splitParagraphs.js
// module id = 861
// module chunks = 0